import script from "./ImpressumView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImpressumView.vue?vue&type=script&setup=true&lang=ts"

import "./ImpressumView.vue?vue&type=style&index=0&id=49beb8ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49beb8ca"]])

export default __exports__